var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hidden"},[_c('el-form-item',{attrs:{"prop":"title"}}),_c('el-form-item',{attrs:{"prop":"key"}}),_c('el-form-item',{attrs:{"prop":"created_at"}}),_c('el-form-item',{attrs:{"prop":"view"}}),_c('el-form-item',{attrs:{"prop":"category"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }